__turbopack_context__.v({
  "className": "wordmarkfont_249a0985-module__rlreYG__className",
});
